import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'kocher_beck',
} as IModuleProps;
